@if (isLoading) {
  <div class="inventory-item-tab__spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

@if (viewModel$ | async; as vm) {
  <div class="inventory-item-info-tab" [formGroup]="overviewForm.form">
    @if (vm.previewFieldLabelKey) {
      <p class="inventory-item-info-tab__notice">
        {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.PREVIEW_UPDATED' | translate: { field: (vm.previewFieldLabelKey | translate) } }}
      </p>
    }

    @if (inventoryItem$ | async; as item) {
      <div class="inventory-item-info-tab__composite">
        <label class="inventory-item-info-tab__composite-toggle">
          <input
            type="checkbox"
            class="inventory-item-info-tab__composite-input"
            [checked]="isCompositeChecked"
            [disabled]="isCompositeSaving || item.isArchived === true"
            (change)="onCompositeToggleChange($any($event.target).checked)"
          />
          <span class="inventory-item-info-tab__composite-label">
            {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.COMPONENTS.COMPOSITE_TOGGLE' | translate }}
          </span>
        </label>
        @if (compositeErrorKey) {
          <p class="inventory-item-info-tab__composite-error" role="alert">
            {{ compositeErrorKey | translate }}
          </p>
        }
      </div>
    }

    <div class="inventory-item-info-tab__fields">
      @for (field of vm.infoFields; track field.controlName) {
        <app-dynamic-editable-field
          class="inventory-item-info-tab__field"
          [formControlName]="field.controlName"
          layout="stacked"
          [editable]="field.editable !== false"
          [inputType]="field.inputType ?? 'text'"
          inputClass="input-sm"
          [enumName]="field.enumName ?? ''"
          [enumObject]="field.enumObject"
          [selectItems]="field.selectItems"
          (updatedInput)="onPreviewFieldUpdate(field.controlName)"
        >
          <ng-template #labelTpl>
            <div class="inventory-item-info-tab__field-label">
              {{ field.label | translate }}
            </div>
          </ng-template>
          <ng-template #contentTpl>
            <div class="inventory-item-info-tab__field-value" [ngClass]="field.valueClass">
              @if (field.valueKey) {
                {{ field.valueKey | translate }}
              } @else {
                {{ field.value }}
              }
            </div>
          </ng-template>
        </app-dynamic-editable-field>
      }
    </div>
  </div>
}
